import { type InputHTMLAttributes, forwardRef } from 'react';

import { cn } from '@/lib/utils';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        'flex h-10 w-full rounded-md border border-ugin-border bg-ugin-surface-elevated px-3 py-2 text-sm text-ugin-text',
        'placeholder:text-ugin-text-faint',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ugin-accent focus-visible:ring-offset-2 focus-visible:ring-offset-ugin-bg',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'transition-colors',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
